module.exports = __webpack_public_path__ + "static/media/match.d846d4e7.mp3";